export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-6">
            关于97影院
          </h2>
          <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            <p>
              97影院是一个专注于<strong>电视剧全集在线观看</strong>的综合性追剧平台。我们致力于为广大剧迷提供最新、最全、最流畅的电视剧观看体验。无论你是国产剧的忠实拥趸、韩剧的狂热粉丝，还是美剧的资深鉴赏家，在这里都能找到心仪的剧集。
            </p>
            <p>
              平台覆盖<strong>热门国产剧、高分韩剧、口碑美剧</strong>三大核心品类，同时延伸至日剧、泰剧、台剧等多元内容。所有剧集均为高清蓝光画质，配合全球加速网络，确保观影流畅不卡顿。我们坚持<strong>每日同步更新</strong>，与电视台和流媒体平台保持同步，让你追剧永远快人一步。
            </p>
            <p>
              自上线以来，97影院已积累超过<strong>20000部剧集资源</strong>，服务数百万追剧用户。我们始终以用户体验为核心，持续优化播放技术和内容覆盖，打造最值得信赖的<strong>免费在线观看</strong>平台。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}